import React from "react";
import "./AboutContent.css";
const content = [
  {
    title: "Our approach",
    description:
      "We believe that conversations are at the heart of building long-lasting customer relationships. That's why we've designed our AI agents to be more than just efficient. They are conversational, useful, empathetic, and authentic. Our platform empowers businesses to redefine what's possible in customer relationships—all with the efficiency and scale of AI.",
  },
  {
    title: "Our customers",
    description:
      "Sendbird is the engine behind meaningful connections for 6 billion people worldwide, powering 7 billion conversations every month. Our platform supports leaders across a diverse range of industries, including delivery & rideshare, e-commerce & retail, healthcare, travel & hospitality, and financial services.",
  },
  {
    title: "Our belief",
    description:
      "We believe in a future where AI unlocks human potential across all facets of life. We envision an A2A (Agent-to-Agent) world where AI agents connect businesses and individuals, empowering them to achieve more than ever before. It’s a future where the impossible becomes possible, and human achievement is no longer bound by time and cognitive load.",
  },
];
function AboutContent() {
  return (
    <section className="about-content-section container">
      {content.map((item, index) => (
        <React.Fragment key={index}>
          <div className="about-content-row">
            <div className="about-content-title">
              <h5>{item.title}</h5>
            </div>
            <div className="about-content-description">
              <p>{item.description}</p>
            </div>
          </div>
          {index < content.length - 1 && <hr className="content-divider" />}
        </React.Fragment>
      ))}
    </section>
  );
}
export default AboutContent;
